import { Body, breakpoints, Header, Spacer } from '@spritz-finance/ui'
import styled from 'styled-components'
import SpritzLogo from '../../../assets/icons/logo.png'

const HeaderContainer = styled.div`
    margin: 12px auto 16px;

    ${breakpoints.xsmall} {
        margin-bottom: 30px;
    }
`

const Logo = styled.img`
    width: 60px;
    height: 54px;

    ${breakpoints.xsmall} {
        margin-bottom: 10px;
    }
`

const Subtitle = styled.div`
    ${breakpoints.xsmall} {
        display: none;
    }
`

type HeaderProps = { title: string; subtitle?: string }

export const PublicLayoutHeader = ({ title, subtitle }: HeaderProps) => {
    return (
        <HeaderContainer>
            <Logo src={SpritzLogo} />
            <Spacer height={32} />
            <Header.SmBold style={{ margin: 0 }}>{title}</Header.SmBold>
            {subtitle && (
                <Subtitle>
                    <Spacer height={4} />
                    <Body.Med size={14}>{subtitle}</Body.Med>
                </Subtitle>
            )}
        </HeaderContainer>
    )
}
